import React from "react";

const Observation = () => {
  return (
    <div className="cyclone-data">
      {/* <h6
        style={{
          textAlign: "left",
          fontSize: "1.5rem",
          backgroundColor: "rgb(202, 217, 239)",
          fontWeight: "bold",  
          padding: "0.5rem 1rem",
          borderRadius: "6px",
          marginBottom: "1rem"
        }}
      >
        Tropical Depression/ Cyclone Track Information:
      </h6> */}
      <p>
        <strong>Observed Track:</strong>
      </p>
      <table className="municipality-tables">
        <thead>
        <tr>
            <th>Cyclone Speed For Past 6 Hours (M/S)</th>
            <th>Latitude °N & Longitude °E</th>
            <th>Time(TLT) hrs</th>
            <th>Maximum Sustained Winds(m/s)</th>
          </tr>
        </thead>
        <tbody>
        <tr>
            <td>0</td>
            <td>13.6 °N, 84.2 °E</td>
            <td>HH:MM</td>
            <td>0</td>
          </tr>
          <tr>
            <td>0</td>
            <td>13.6 °N, 84.2 °E</td>
            <td>HH:MM</td>
            <td>0</td>
          </tr>
        </tbody>
      </table>

      <p>
        <strong>Forecast Track:</strong>
      </p>

      <table className="municipality-tables">
        <thead>
        <tr>
        <th>Date & Time (TLT)</th>
            <th>Latitude °N & Longitude °E</th>
            <th>Intensity (kts)</th>
            <th>Max Intensity (kts)</th>
            <th>MSLP (mb)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>YYYY-MM-DD/23:30</td>
            <td>13.6 °N, 84.2 °E</td>
            <td>15</td>
            <td>200</td>
            <td>9999</td>
          </tr>
          <tr>
            <td>YYYY-MM-DD/05:30</td>
            <td>13.6 °N, 84.2 °E</td>
            <td>16</td>
            <td>210</td>
            <td>9999</td>
          </tr>
          <tr>
            <td>YYYY-MM-DD/11:30</td>
            <td>13.6 °N, 84.2 °E</td>
            <td>17</td>
            <td>210</td>
            <td>9999</td>
          </tr>
          <tr>
            <td>YYYY-MM-DD/17:30</td>
            <td>13.6 °N, 84.2 °E</td>
            <td>18</td>
            <td>210</td>
            <td>9999</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Observation;
